import React from 'react'
import styles from './styles.module.css'

export default function({ children }){
    return (
        <>
            <h1 className={styles.title}>{ children }<button onClick={() => window.location = "/sobre"} className={styles.button}>Saiba Mais</button></h1>
        </>
    )
}